module.exports = __webpack_public_path__ + "img/img_cx9_open.2b3e3e38.jpg";